import Tag from "components/tags/tag"
import { useTranslation } from "react-i18next"
import { memo } from "react"

interface ActionBadgeProps {
    type: string
    amount: number
}

const ActionBadge: React.FC<ActionBadgeProps> = ({ type, amount }) => {

    const { t } = useTranslation()

    switch (type) {
        case 'increment':
            return <Tag colorScheme={`green`}><span className={`!hidden lg:!inline`}>{t('addedAmount')}: </span><span className={`lg:hidden`}>+</span>{Math.abs(amount)}</Tag>
        case 'decrement':
            return <Tag colorScheme={`red`}><span className={`!hidden lg:!inline`}>{t('removedAmound')}: </span><span className={`lg:hidden`}>-</span>{Math.abs(amount)}</Tag>
        case 'adjust':
            return <Tag colorScheme={`yellow`}><span className={`!hidden lg:!inline`}>{t('adjustedAmount')}: </span>{amount}</Tag>
        default:
            return null
    }
}

export default memo(ActionBadge)

